import { TranslatedTerms } from "../../globals/TranslatedTerms";
import { DefaultId } from "../../shared/Globals";
import { InvestmentStep } from "../../shared/Investment";
import { InvestmentExperienceEducationalLevelOption, InvestmentKnowledgeOption } from "../../shared/InvestmentKnowledge";
import { TranslationDictionary } from "../../shared/Language";


export const ACTION_TRANSLATION_SUFFIX = "ACTION_TRANSLATION_SUFFIX"

export const InvestmentStepsDictionary: TranslationDictionary = {
    [TranslatedTerms.INVESTMENT_STEP_AMOUNT_TITLE]: {
        [DefaultId]: "Invest",
        "da": "Investér"
    },
    [TranslatedTerms.INVESTMENT_STEP_AMOUNT_DESCRIPTION]: {
        [DefaultId]: "Please indicate how much you would like to lend to this project. Reserve your share now and only pay in when the project is fully subscribed. Don't worry, we'll let you know when it's time to transfer.",
        "da": "Venligst angiv hvor meget du ønsker at udlåne til dette projekt. Reservér din andel nu og indbetal først når projektet er fuldtegnet. Bare rolig, vi giver dig besked når det er tid til at overføre."
    },
    [TranslatedTerms.INVESTMENT_STEP_KYC_TITLE]: {
        [DefaultId]: "Investor information",
        "da": "Investoroplysninger"
    },
    [TranslatedTerms.INVESTMENT_STEP_KYC_DESCRIPTION]: {
        [DefaultId]: "We need your personal information to verify your identity, draw up the loan agreement and to be able to make the necessary registrations with authorities.",
        "da": "Vi skal bruge dine personlige oplysninger til at verificere din identitet, udfærdige låneaftalen og for at kunne foretage nødvendige registreringer hos myndigheder."
    },
    [TranslatedTerms.INVESTMENT_STEP_TERMS_TITLE]: {
        [DefaultId]: "Consent and acceptance of risk",
        "da": "Samtykke og accept af risiko"
    },
    [TranslatedTerms.INVESTMENT_STEP_TERMS_DESCRIPTION]: {
        [DefaultId]: "We must use your personal information to verify your identity and draw up the loan agreement, etc. Please note that Fundbricks only makes the platform available by arranging contact between you and {developer}, and Fundbricks is not responsible for the implementation or management of your lending.",
        "da": "Vi skal bruge dine personlige oplysninger til at verificere din identitet og udfærdige låneaftalen mv. Bemærk at Fundbricks alene stiller platformen til rådighed ved at formidle kontakt mellem dig og {developer}, og Fundbricks er hverken ansvarlig for gennemførelse eller forvaltning af dit udlån."
    },
    [TranslatedTerms.INVESTMENT_STEP_INVESTOR_TEST_TITLE]: {
        [DefaultId]: "Initial knowledge test",
        "da": "Indledende videnstest"
    },
    [TranslatedTerms.INVESTMENT_STEP_INVESTOR_TEST_DESCRIPTION]: {
        [DefaultId]: "This will help us assess whether investments on our platform are suitable for you and/or allow us to warn you about the risks of such investments.",
        "da": "Dette vil hjælpe os til at vurdere om investeringer på vores platform er velegnede for dig og/eller giver os mulighed for at advare dig om risikoen ved sådanne investeringer."
    },
    [TranslatedTerms.INVESTMENT_STEP_INVESTOR_SIMULATION_TITLE]: {
        [DefaultId]: "Simulation tool",
        "da": "Simuleringsværktøjet"
    },
    [TranslatedTerms.INVESTMENT_STEP_INVESTOR_SIMULATION_DESCRIPTION]: {
        [DefaultId]: "This will help us assess whether investments on our platform are suitable for you and/or allow us to warn you about the risks of such investments.",
        "da": "Dette vil hjælpe os til at vurdere om investeringer på vores platform er velegnede for dig og/eller giver os mulighed for at advare dig om risikoen ved sådanne investeringer."
    },
    [TranslatedTerms.INVESTMENT_STEP_TERMS_RISK]: {
        [DefaultId]: "Yes, I am aware of all the risks associated with granting loans to {developer}, as described in more detail in our Risk Description.",
        "da": "Ja, jeg er bekendt med alle risici der er forbundet med at yde lån til {developer}, som nærmere beskrevet i vores Risikobeskrivelse."
    },
    [TranslatedTerms.INVESTMENT_STEP_TERMS_POLICY]: {
        [DefaultId]: "Yes, I am familiar with and accept Fundbrick's Terms of Use.",
        "da": "Ja, jeg er bekendt med og accepterer Fundbricks Brugerbetingelser."
    },
    [TranslatedTerms.INVESTMENT_STEP_TERMS_MARKETING]: {
        [DefaultId]: "Yes, I would like to receive emails via Fundbricks.com with information, news, marketing and offers regarding investment opportunities in real estate projects offered on the platform. We process your personal information as described in our personal data policy. I can revoke the consent at any time partly by contacting Fundbricks.com at hello@fundbricks.com or by using the unsubscribe link in the email.",
        "da": "Ja, jeg vil gerne modtage meddelelser via email fra Fundbricks.com med information, nyheder, markedsføring og tilbud vedrørende investeringsmuligheder i ejendomsprojekter udbudt på platformen. Vi behandler dine personoplysninger som beskrevet i vores persondatapolitik. Jeg kan til enhver tid tilbagekalde samtykket dels ved at kontakte Fundbricks.com på hello@fundbricks.com eller ved at benytte afmeldingslinket i emailen."
    },
    [TranslatedTerms.INVESTMENT_STEP_SIGN_TITLE]: {
        [DefaultId]: "Contract signing",
        "da": "Aftaleindgåelse"
    },
    [TranslatedTerms.INVESTMENT_STEP_SIGN_DESCRIPTION]: {
        [DefaultId]: "We have prepared a loan agreement between you and the project company {developer} which is ready for your signature. Tap next to go to the appointment.",
        "da": "Vi har forberedt en låneaftale mellem dig og projektselskabet {developer} som ligger klar til din underskrift. Tryk på næste for at gå til aftalen."
    },
    [TranslatedTerms.INVESTMENT_STEP_PAYMENT_TITLE]: {
        [DefaultId]: "Payment",
        "da": "Indbetaling"
    },
    [TranslatedTerms.INVESTMENT_STEP_PAYMENT_DESCRIPTION]: {
        [DefaultId]: "Congratulations, the agreement has been signed and final. The last step is to pay the loan amount into the deposit account.",
        "da": "Tillykke, aftalen er underskrevet og endelig. Sidste skridt er at indbetale udlånsbeløbet til deponeringskontoen."
    },
    [TranslatedTerms.INVESTMENT_STEP_SUCESS_TITLE]: {
        [DefaultId]: "Congratulations",
        "da": "Tillykke"
    },
    [TranslatedTerms.INVESTMENT_STEP_SUCESS_DESCRIPTION]: {
        [DefaultId]: "We have registered your deposit to the deposit account.",
        "da": "Vi har registreret din indbetaling til deponeringskontoen."
    },
    [TranslatedTerms.INVESTMENT_STEP_SUB_SUCESS_DESCRIPTION]: {
        [DefaultId]: "When the project is fully funded, your loan will be locked and the project will be realized. Otherwise, your loan will be refunded when the project campaign ends.",
        "da": "Når projektet bliver fuldtegnet bliver dit udlån låst og projektet realiseres. Ellers vil dit udlån blive tilbagebetalt når projektets kampagne afsluttes."
    },
    [InvestmentStep.InvestmentAmountStep + ACTION_TRANSLATION_SUFFIX]: {
        [DefaultId]: "Amount not selected",
        "da": "Beløb ikke udfyldt"
    },
    [InvestmentStep.KYCDataStep + ACTION_TRANSLATION_SUFFIX]: {
        [DefaultId]: "Add your information",
        "da": "Tilføj dine oplysninger"
    },
    [InvestmentStep.AcceptTerms + ACTION_TRANSLATION_SUFFIX]: {
        [DefaultId]: "Accept terms",
        "da": "Accepter vilkår"
    },
    [InvestmentStep.InvestorTest + ACTION_TRANSLATION_SUFFIX]: {
        [DefaultId]: "Investor test",
        "da": "Investor test"
    },
    [InvestmentStep.Contract + ACTION_TRANSLATION_SUFFIX]: {
        [DefaultId]: "Contract signature",
        "da": "Underskriv kontrakt"
    },
    [InvestmentStep.Transfer + ACTION_TRANSLATION_SUFFIX]: {
        [DefaultId]: "Transfer funds",
        "da": "Overfør penge"
    },
    [InvestmentStep.Congratulations + ACTION_TRANSLATION_SUFFIX]: {
        [DefaultId]: "Deposit registered",
        "da": "Indbetaling registreret"
    },
    [InvestmentStep.InvestmentDetails + ACTION_TRANSLATION_SUFFIX]: {
        [DefaultId]: "See investment",
        "da": "Se investering"
    },
    [InvestmentStep.InvestmentAmountStep]: {
        [DefaultId]: "Amount",
        "da": "Beløb"
    },
    [InvestmentStep.KYCDataStep]: {
        [DefaultId]: "Information",
        "da": "Oplysninger"
    },
    [InvestmentStep.AcceptTerms]: {
        [DefaultId]: "Terms",
        "da": "Vilkår"
    },
    [InvestmentStep.InvestorTest]: {
        [DefaultId]: "Investor test",
        "da": "Investor test"
    },
    [InvestmentStep.Contract]: {
        [DefaultId]: "Sign contract",
        "da": "Underskriv kontrakt"
    },
    [InvestmentStep.Transfer]: {
        [DefaultId]: "Transfer funds",
        "da": "Overfør penge"
    },
    [InvestmentStep.Congratulations]: {
        [DefaultId]: "Congratulations",
        "da": "Tillykke"
    },
    [InvestmentStep.InvestmentDetails]: {
        [DefaultId]: "Manage investment",
        "da": "Følg investering"
    },
    [TranslatedTerms.IN_X_MONTHS_YOU_WILL_HAVE_RECIVED_X_AMOUNT_NOT_BAD_HUH]: {
        [DefaultId]: "In {durationMin} - {durationMax} months you'll recive {profitMin} - {profitMax} in interest - not bad, right?",
        "da": "Om {durationMin} - {durationMax} mdr. vil du have tjent {profitMin} - {profitMax} - ikke dårligt, vel?"
    },
    [InvestmentKnowledgeOption.ListedStocks]: {
        [DefaultId]: "Listed stocks",
        "da": "Børsnoterede aktier"
    },
    [InvestmentKnowledgeOption.Bonds]: {
        [DefaultId]: "Bonds",
        "da": "Obligationer"
    },
    [InvestmentKnowledgeOption.InvestmentAssociations]: {
        [DefaultId]: "Investment associations",
        "da": "Investeringsforeninger"
    },
    [InvestmentKnowledgeOption.CrowdfundingCrowdlending]: {
        [DefaultId]: "Crowdfunding/crowdlending"
    },
    [InvestmentKnowledgeOption.Other]: {
        [DefaultId]: "Other",
        "da": "Andet"
    },
    [InvestmentExperienceEducationalLevelOption.ElementarySchool]: {
        [DefaultId]: "Elementary School",
        "da": "Folkeskolen (9. klasse)"
    },
    [InvestmentExperienceEducationalLevelOption.TenthGrade]: {
        [DefaultId]: "10. grade",
        "da": "10. klasse"
    },
    [InvestmentExperienceEducationalLevelOption.ShortHigherEducation]: {
        [DefaultId]: "Short higher education (1-2 years)",
        "da": "Kort videregående uddannelse (1-2 år)"
    },
    [InvestmentExperienceEducationalLevelOption.MediumHigherTermEducation]: {
        [DefaultId]: "Intermediate vocational education (3-4 years)",
        "da": "Mellemlang videregående uddannelse (3-4 år)"
    },
    [InvestmentExperienceEducationalLevelOption.LongHigherTermEducation]: {
        [DefaultId]: "Long-term vocational education (5+ years)",
        "da": "Lang videregående uddannelse (5+ år)"
    },
    [InvestmentExperienceEducationalLevelOption.Phd]: {
        [DefaultId]: "Ph.D."
    },
    [TranslatedTerms.RISK_WARNING]: {
        [DefaultId]: "Risk warning for potentially less experienced investors",
        "da": "Risikoadvarsel til potentielt mindre erfarne investorer"
    },
    [TranslatedTerms.SIMULATION_RESULT]: {
        [DefaultId]: "Simulation result",
        "da": "Resultat af simulation"
    },
    [TranslatedTerms.RISK_WARNING_LESS_EXPERIENCEDP1]: {
        [DefaultId]: "Every investment involves a risk. This also applies to the crowdfunding projects that you can invest in at Fundbricks, and we must therefore point out that investing in a crowdfunding project involves the risk of losing the entire invested amount and that the investment is not covered by the deposit guarantee schemes pursuant to Directive 2014/49/EU or 97/9/EU. Thus, the services offered on Fundbricks' crowdfunding platform may be unsuitable for you.",
        "da": "Enhver investering indebærer en risiko. Dette gælder også de crowdfundingprojekter, som du kan investere i hos Fundbricks og og vi skal derfor gøre opmærksom på at investering i et crowdfundingprojekt indebærer risiko for, at hele det investerede beløb går tabt og at investeringen ikke er dækket af indskudsgarantiordningerne i medfør af direktiv 2014/49/EU eller 97/9/EU. Dermed kan de tjenester, som udbydes på Fundbricks' crowdfundingplatform, muligvis være uhensigtsmæssige for dig."
    },
    [TranslatedTerms.RISK_WARNING_LESS_EXPERIENCEDP2]: {
        [DefaultId]: "For a detailed description of the risks associated with investing at Fundbricks, please see our risk description at",
        "da": "For nærmere beskrivelse af de risici, som er forbundet med investering hos Fundbricks, se venligst vores risikobeskrivelse på "
    },
    [TranslatedTerms.RISK_WARNING_LESS_EXPERIENCEDP3]: {
        [DefaultId]: "We would like to point out that according to the crowdfunding regulation, you have a 4-day reflection period. If you regret your investment within 4 days of entering into it, you can request its cancellation by writing to us at: ",
        "da": "Vi gør opmærksom på at du i henhold til crowdfundingforordningen har 4 dages betænkningstid. Skulle du således fortryde din investering indenfor 4 dage fra indgåelsen, kan du bede om at få den annulleret ved at skrive til os på: "
    },
    [TranslatedTerms.RISK_WARNING_LESS_EXPERIENCED_ACCEPTENCE]: {
        [DefaultId]: "I confirm that I have understood the investment and its risks as well as the reflection period.",
        "da": "Jeg bekræfter at jeg har forstået investeringen og dens risici samt betænkningstiden."
    },
    [TranslatedTerms.APPLY_FOR_MORE_EXPERIENCED_BUTTON]: {
        [DefaultId]: "Apply to be considered a more experienced investor",
        "da": "Ansøg om at blive betragtet som mere erfaren investor."
    },
}